export enum EmployeeAvatarSizes {
  Small = 1,
  Medium = 2,
  Large = 3,
}
